export const RequestPasswordResetDialogTranslationKeys = {
  title: 'requestPasswordResetTitle',
  pleaseEnterEmail: 'requestPasswordResetEnterEmail',
  resetPasswordButton: 'requestPasswordResetPasswordResetButton',
  email: {
    title: 'membersLoginDialogEmailField',
    label: 'membersLoginDialogEmailField',
  },
};
